(function observeSwymAddToCartClicks() {
  const observer = new MutationObserver(() => {
    const buttons = document.querySelectorAll(
      'button.swym-add-to-cart-btn:not([data-safeguard-attached])'
    );

    buttons.forEach((btn) => {
      btn.setAttribute('data-safeguard-attached', 'true');

      btn.addEventListener('click', () => {
        console.log('[Swym Fallback] Detected click on Swym Add to Cart button');

        // Delay to allow Swym to process the cart update 
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
              console.log('[Swym Fallback] Cart refreshed manually via /cart.js');
            })
            .catch((err) => {
              console.warn('[Swym Fallback] Failed to fetch cart:', err);
            });
        }, 1000); // Adjust delay if necessary
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
